import React from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography
} from '@material-ui/core';

export function decisionCopy({ decision, carrierName, groupName, scope }) {
    const verb = decision === 'accept' ? 'Accept' : 'Decline';
    const carrier = carrierName || 'this carrier';
    if (scope === 'group' || groupName) {
        return groupName
            ? `${verb} the ${groupName} group from ${carrier}?`
            : `${verb} the selected group from ${carrier}?`;
    }
    if (scope === 'pending') {
        return `${verb} every pending group from ${carrier}? Groups you already decided stay unchanged.`;
    }
    return `${verb} the sharing agreement from ${carrier}? This applies to the whole request.`;
}

const ConfirmDecisionDialog = ({
    open,
    decision,
    carrierName,
    groupName,
    scope,
    onCancel,
    onConfirm
}) => {
    const verb = decision === 'accept' ? 'Accept' : 'Decline';
    return (
        <Dialog open={Boolean(open)} onClose={onCancel} aria-labelledby="sharing-decision-title">
            <DialogTitle id="sharing-decision-title">{verb} sharing agreement</DialogTitle>
            <DialogContent>
                <Typography>{decisionCopy({ decision, carrierName, groupName, scope })}</Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onCancel}>Cancel</Button>
                <Button color="primary" onClick={onConfirm} id="confirm-sharing-decision">
                    {verb}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmDecisionDialog;
